import axios from "axios";

export default {
    async requestNotifications({ commit }) {
        commit('loadingNotifications');

        try {
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/notifications/`);
            commit('successNotifications', response.data);
            commit('resetSuccessNotifications');
            return true;
        } catch(error) {
            commit('errorNotifications', error.response.data);
            return false;   
        }
    },
    async changeNotificationState({ commit, state }) {
        commit('loadingViewedNotif');

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_BACKEND_API}/notifications/bulk/`,
                state.willVisualize.data
            );
            commit('successViewedNotif');
            commit('resetSuccessViewedNotif');
            return true;
        } catch(error) {
            commit('errorViewedNotif', error.response.data);
            return false;
        }
    },
};  
